import React from "react";

const TONES = {
  petrol: { color: "#3F6A70", border: "rgba(63,106,112,0.45)", bg: "rgba(63,106,112,0.06)" },
  gold: { color: "#A07A28", border: "rgba(160,122,40,0.45)", bg: "rgba(160,122,40,0.06)" },
  muted: { color: "#8A8580", border: "rgba(138,133,128,0.4)", bg: "transparent" },
  green: { color: "#4D6B3C", border: "rgba(77,107,60,0.45)", bg: "rgba(77,107,60,0.06)" },
};

export function Pill({ tone = "muted", children, testId }) {
  const t = TONES[tone];
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center px-2.5 py-1 border font-body text-[10.5px] tracking-[0.18em] uppercase whitespace-nowrap"
      style={{ color: t.color, borderColor: t.border, background: t.bg }}
    >
      {children}
    </span>
  );
}

export const btnPrimary =
  "cta-graphite inline-flex items-center justify-center gap-2 px-6 py-3 text-[11.5px] uppercase font-body font-medium tracking-[0.2em] disabled:opacity-50 disabled:cursor-not-allowed";
export const btnGhost =
  "inline-flex items-center justify-center gap-2 px-5 py-3 border border-hairline bg-white text-graphite text-[11.5px] uppercase font-body tracking-[0.18em] hover:border-[#A07A28] hover:text-[#A07A28] transition-colors duration-200 disabled:opacity-40 disabled:cursor-not-allowed";
export const fieldLabel = "block font-body text-[10.5px] tracking-[0.28em] uppercase text-muted-warm mb-1.5";
export const fieldInput =
  "w-full bg-white border border-hairline px-3.5 py-2.5 font-body text-[15px] text-graphite outline-none focus:border-[#A07A28] transition-colors duration-200";
export const card = "bg-white border border-hairline";
